export default "__VITE_ASSET__3d615225__"